export var TRANSFER_STATUS;
(function (TRANSFER_STATUS) {
    TRANSFER_STATUS["\uBBF8\uC1A1\uAE08"] = "\uBBF8\uC1A1\uAE08";
    TRANSFER_STATUS["\uC1A1\uAE08\uC911"] = "\uC1A1\uAE08\uC911";
    TRANSFER_STATUS["\uC1A1\uAE08\uC644\uB8CC"] = "\uC1A1\uAE08\uC644\uB8CC";
})(TRANSFER_STATUS || (TRANSFER_STATUS = {}));
export var INBOUND_STATUS;
(function (INBOUND_STATUS) {
    INBOUND_STATUS["\uBBF8\uC785\uACE0"] = "\uBBF8\uC785\uACE0";
    INBOUND_STATUS["\uC785\uACE0\uC911"] = "\uC785\uACE0\uC911";
    INBOUND_STATUS["\uC785\uACE0\uC644\uB8CC"] = "\uC785\uACE0\uC644\uB8CC";
})(INBOUND_STATUS || (INBOUND_STATUS = {}));
export var ORDER_APPROVAL_PHASE;
(function (ORDER_APPROVAL_PHASE) {
    ORDER_APPROVAL_PHASE["\uBC1C\uC8FC\uC791\uC131"] = "\uBC1C\uC8FC\uC791\uC131";
    ORDER_APPROVAL_PHASE["\uBBF8\uD655\uC778"] = "\uBBF8\uD655\uC778";
    ORDER_APPROVAL_PHASE["\uBBF8\uC2B9\uC778"] = "\uBBF8\uC2B9\uC778";
    ORDER_APPROVAL_PHASE["\uC9C4\uD589\uC911"] = "\uC9C4\uD589\uC911";
    ORDER_APPROVAL_PHASE["\uBC18\uB824"] = "\uBC18\uB824";
    ORDER_APPROVAL_PHASE["\uAD6C\uB9E4\uC644\uB8CC"] = "\uAD6C\uB9E4\uC644\uB8CC";
})(ORDER_APPROVAL_PHASE || (ORDER_APPROVAL_PHASE = {}));
